import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment as ENV } from "environments/environment";
import { Observable, Subject } from 'rxjs';
import { DocumentoDTO } from '../../interfaces/documento.interface';
import { PersonaDTO } from '../../interfaces/persona.interface';

const API = "personas";


@Injectable({
  providedIn: 'root'
})
export class PersonasService {
 
documentosChanged$: Subject<boolean>;  
constructor(private http: HttpClient) {
  this.documentosChanged$ = new Subject();
}

fetchPersona(nrRut:number): Observable<PersonaDTO> {   
  return this.http.get<PersonaDTO>(`${ENV.apiUrl}${API}/${nrRut}`);
}

fetchDocumentos(rut: number): Observable<DocumentoDTO[]> {
  return this.http.get<DocumentoDTO[]>(
    `${ENV.apiUrl}${API}/${rut}/documentos`
  );
}

fetchDocumento(idDocumento: number, rut: number): Observable<Blob> {
  const requestOptions: Object = {
    responseType: 'blob',
  };
  return this.http.get<any>(
    `${ENV.apiUrl}${API}/${rut}/documento/${idDocumento}`,
    requestOptions
  );
}

saveDocumento(
  tipo: string,
  rut: number,
  fechaVencimiento: string,
  archivo: any
): Observable<any> {
  let json = { idTipo: tipo, vencimiento: fechaVencimiento };

  let form = new FormData();
  form.append('documento', JSON.stringify(json));
  form.append('archivo', archivo);

  return this.http.post(`${ENV.apiUrl}${API}/${rut}/documento`, form, {
    reportProgress: true,
  });
}


deleteDocumento(idDocumento: number, rut: number):Observable<any> {
  return this.http.delete(
    `${ENV.apiUrl}${API}/${rut}/documento/${idDocumento}`,{
      responseType: 'text',
    }
  );
}


}
///api/personas/{rutPersona}